/* eslint-disable vtex/prefer-early-return */
import { useEffect, useState } from 'react'
import { useLocation } from '@reach/router'
import { readCookie, setCookie } from 'src/utils/cookies'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import { resolveSessionAttributionString } from 'src/utils/sessionAttribution'

import PopUpredirectToApp from './PopUpredirectToApp'
import './styles.scss'
import PopUpInstallAppVersionB from './PopUpInstallAppB'

export type ButtonsAppsProps = 'install-app' | 'open-app'

export type ActionAppsProps = 'Sim' | 'Não' | 'X'

const PopUpAppsflyer = () => {
  const { search } = useLocation()
  const { pageData } = useGlobalContext()
  const standardObject = getStandardObject(pageData)

  const [isAppRefused, setIsAppRefused] = useState<boolean>(false)

  const [modalOpenApp, setModalOpenApp] = useState<boolean>(true)

  useEffect(() => {
    setIsAppRefused(readCookie('refuseApp=true'))
    setModalOpenApp(!readCookie('appInstalled=true'))
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined' && typeof document !== 'object') {
      return
    }

    window.dataLayer = window.dataLayer || []

    if (document.querySelector('.install-app')?.classList.contains('flex')) {
      const obj = {
        event: 'ga_custom_event',
        event_category: 'Popup APP',
        event_action:
          '(Resumo: APP Decathlon não encontrado. Deseja instalar?)',
        event_label: 'Banner exibido',
        event_is_user_interaction: false,
      }

      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push(obj)

      return
    }

    if (document.querySelector('.open-app')?.classList.contains('flex')) {
      const obj = {
        event: 'ga_custom_event',
        event_category: 'Popup APP',
        event_action: '(Resumo: APP Decathlon encontrado. Deseja abrir?)',
        event_label: 'Banner exibido',
        event_is_user_interaction: false,
      }

      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push(obj)
    }
  })

  const handleSendEvent = (
    action: ActionAppsProps,
    modal: ButtonsAppsProps
  ): void => {
    const obj = {
      event: 'ga_custom_event',
      event_category: 'Popup APP',
      event_action:
        modal === 'install-app'
          ? '(Resumo: APP Decathlon não encontrado. Deseja instalar?)'
          : '(Resumo: APP Decathlon encontrado. Deseja abrir?)',
      event_label: `Interacao: ${action}`,
      event_is_user_interaction: true,
    }

    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || []

      window.dataLayer.push({ ecommerce: null })
      window.dataLayer.push(obj)
    }
  }

  const handleCloseApp = (): void => {
    setModalOpenApp(true)
    setCookie('appInstalled', 'false', { expiresInMinutes: 365 * 24 * 60 })
  }

  const handleClickYes = (action: ButtonsAppsProps): void | undefined => {
    const rawSessionAttribution = resolveSessionAttributionString(search)

    const adjCampaign = rawSessionAttribution
      ? encodeURIComponent(rawSessionAttribution)
      : 'm-site'

    if (typeof window === 'undefined') {
      return undefined
    }

    const adjAdgroup = 'experiencia_b'

    const goToAppUrl = `https://decathlonbrasil.go.link?adj_t=1p4oksrs&adj_campaign=${adjCampaign}&adj_adgroup=${adjAdgroup}&adj_creative=popup`

    if (action === 'install-app') {
      setCookie('appInstalled', 'true', { expiresInMinutes: 365 * 24 * 60 })

      window.location.href = goToAppUrl

      return
    }

    window.location.href = goToAppUrl
    setModalOpenApp(true)
  }

  const handleClickNo = (): void => {
    setIsAppRefused(true)
  }

  return (
    <div className="modals-appsflyer">
      <PopUpredirectToApp
        handleClickNo={handleClickNo}
        handleClickYes={handleClickYes}
        handleCloseApp={handleCloseApp}
        handleSendEvent={handleSendEvent}
        isAppRefused={isAppRefused}
        modalOpenApp={modalOpenApp}
        standardObject={standardObject}
      />
      <PopUpInstallAppVersionB
        handleClickYes={handleClickYes}
        handleSendEvent={handleSendEvent}
        standardObject={standardObject}
      />
    </div>
  )
}

export default PopUpAppsflyer
